module.exports = __webpack_public_path__ + "media/images/applicant/icon-student-113854cc9d609d51a802d9092a8008c6.svg";